import { defineMessages } from 'react-intl';
export default defineMessages({
    addForecastModel: {
        id: 'forecastModels.addForecastModel',
        defaultMessage: 'Add a model'
    },
    atYourStations: {
        id: 'forecastModels.atYourStations',
        defaultMessage: 'Available at your stations'
    },
    coverageLoading: {
        id: 'forecastModels.coverageLoading',
        defaultMessage: 'Working out which of your stations each model covers\u2026'
    },
    description_AROME: {
        id: 'forecastModels.description_AROME',
        defaultMessage: "Météo France's high-resolution convection-allowing model over Western Europe at 1.3 km resolution. Best-in-class for short-term forecasts in France; refreshed every three hours."
    },
    description_ARPEGE_EU: {
        id: 'forecastModels.description_ARPEGE_EU',
        defaultMessage: "Météo France's European nest of the ARPEGE model at 10 km resolution. Mid-range forecasts over Europe, refreshed four times daily."
    },
    description_ARPEGE_GLOBAL: {
        id: 'forecastModels.description_ARPEGE_GLOBAL',
        defaultMessage: "Météo France's global numerical weather model at 25 km resolution, running to about 4 days. Refreshed four times daily."
    },
    description_DMI_DINI: {
        id: 'forecastModels.description_DMI_DINI',
        defaultMessage: "DMI's HARMONIE DINI: a convection-allowing model over northwest Europe — Denmark, the Benelux, Ireland, the UK and Scandinavia — at 2 km resolution out to 60 hours, refreshed eight times daily. Contains modified DMI open data (CC BY 4.0)."
    },
    description_EC_GDPS: {
        id: 'forecastModels.description_EC_GDPS',
        defaultMessage: "Environment Canada's Global Deterministic Prediction System: a worldwide medium-range model at 15 km resolution running out to 10 days, updated twice daily."
    },
    description_EC_HRDPS: {
        id: 'forecastModels.description_EC_HRDPS',
        defaultMessage: "Environment Canada's High Resolution Deterministic Prediction System: a convection-allowing model over Canada and the northern United States at 2.5 km resolution out to 48 hours, refreshed four times daily."
    },
    description_EC_RDPS: {
        id: 'forecastModels.description_EC_RDPS',
        defaultMessage: "Environment Canada's Regional Deterministic Prediction System: a mid-range model over North America at 10 km resolution, refreshed four times daily."
    },
    description_ECMWF_HRES: {
        id: 'forecastModels.description_ECMWF_HRES',
        defaultMessage: "The European Centre for Medium-Range Weather Forecasts' flagship high-resolution model (IFS), widely regarded as the world's leading global forecast system. Covers the entire planet at 25 km resolution out to 15 days, updated four times daily. Contains modified ECMWF open data (CC BY 4.0)."
    },
    description_GFS: {
        id: 'forecastModels.description_GFS',
        defaultMessage: "NOAA's flagship medium-range global model. Covers the entire planet at 25 km resolution out to 16 days, updated four times per day."
    },
    description_HRRR_CONUS: {
        id: 'forecastModels.description_HRRR_CONUS',
        defaultMessage: "NOAA's High-Resolution Rapid Refresh: a convection-allowing model over the continental United States at 3 km resolution, refreshed every hour. Best suited for very short-term forecasts of thunderstorms and severe weather."
    },
    description_ICON: {
        id: 'forecastModels.description_ICON',
        defaultMessage: "DWD's global ICON model at 13 km resolution covering the entire planet out to 7.5 days, refreshed four times daily. Datenbasis: Deutscher Wetterdienst."
    },
    description_ICON_2I: {
        id: 'forecastModels.description_ICON_2I',
        defaultMessage: "ItaliaMeteo's ICON-2I, run jointly with ARPAE: a convection-allowing model over Italy at 2.2 km resolution out to 72 hours, refreshed twice daily. Contains ItaliaMeteo open data (CC BY 4.0)."
    },
    description_ICON_CH1: {
        id: 'forecastModels.description_ICON_CH1',
        defaultMessage: "MeteoSwiss's ICON-CH1-EPS control run: a convection-allowing model over the Alps at 1 km resolution out to 33 hours, refreshed every three hours."
    },
    description_ICON_CH2: {
        id: 'forecastModels.description_ICON_CH2',
        defaultMessage: "MeteoSwiss's ICON-CH2-EPS control run: a convection-allowing model over the Alps — Switzerland and the surrounding Alpine region — at 2.1 km resolution out to 120 hours, refreshed four times daily."
    },
    description_ICON_DE: {
        id: 'forecastModels.description_ICON_DE',
        defaultMessage: "DWD's high-resolution convection-allowing model over Germany and surrounding countries at 2.2 km resolution. Short-term forecasts refreshed twice daily. Datenbasis: Deutscher Wetterdienst."
    },
    description_ICON_EU: {
        id: 'forecastModels.description_ICON_EU',
        defaultMessage: "DWD's European nest of the ICON model at 7 km resolution covering Europe and the North Atlantic. Mid-range forecasts refreshed four times daily. Datenbasis: Deutscher Wetterdienst."
    },
    description_MET_NORWAY: {
        id: 'forecastModels.description_MET_NORWAY',
        defaultMessage: "The Norwegian Meteorological Institute's open weather forecast service, blending high-resolution Nordic models with ECMWF data to provide worldwide forecasts up to 10 days ahead."
    },
    description_MF_AROME_ANTILLES: {
        id: 'forecastModels.description_MF_AROME_ANTILLES',
        defaultMessage: 'AROME nest over the French Antilles (Guadeloupe, Martinique) at 2.5 km resolution. Short-term forecasts refreshed four times daily.'
    },
    description_MF_AROME_GUYANE: {
        id: 'forecastModels.description_MF_AROME_GUYANE',
        defaultMessage: 'AROME nest over French Guiana at 2.5 km resolution. Short-term forecasts refreshed four times daily.'
    },
    description_MF_AROME_NOUVELLE_CALEDONIE: {
        id: 'forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE',
        defaultMessage: 'AROME nest over New Caledonia at 2.5 km resolution. Short-term forecasts refreshed four times daily.'
    },
    description_MF_AROME_POLYNESIE: {
        id: 'forecastModels.description_MF_AROME_POLYNESIE',
        defaultMessage: 'AROME nest over French Polynesia at 2.5 km resolution. Short-term forecasts refreshed four times daily.'
    },
    description_MF_AROME_REUNION_MAYOTTE: {
        id: 'forecastModels.description_MF_AROME_REUNION_MAYOTTE',
        defaultMessage: 'AROME nest over Réunion and Mayotte at 2.5 km resolution. Short-term forecasts refreshed four times daily.'
    },
    description_RRFS_CONUS: {
        id: 'forecastModels.description_RRFS_CONUS',
        defaultMessage: "NOAA's Rapid Refresh Forecast System over the continental United States at 3 km resolution. Hourly forecasts refreshed eight times daily, reaching 84 hours on the four main runs and 18 hours on the others."
    },
    description_RRFS_NORTH_AMERICA: {
        id: 'forecastModels.description_RRFS_NORTH_AMERICA',
        defaultMessage: "NOAA's Rapid Refresh Forecast System covering all of North America at 13 km resolution. Hourly forecasts to 84 hours, refreshed four times daily."
    },
    description_SMARTMIXIN_MULTIMODEL: {
        id: 'forecastModels.description_SMARTMIXIN_MULTIMODEL',
        defaultMessage: "SmartMixin's flagship forecast. For every hour at your location, we pick the best model available — typically a high-resolution regional model where one exists (AROME in France, ICON-D2 in Germany, HRRR in the United States, ARPEGE Europe across the continent…) and fall back to a global model elsewhere — then fill any gaps from neighbouring sources. The result is a single, seamless forecast covering anywhere in the world out to 14 days, refreshed automatically whenever any of the underlying models is updated."
    },
    description_WEATHERFLOW_FORECAST: {
        id: 'forecastModels.description_WEATHERFLOW_FORECAST',
        defaultMessage: "Weatherflow's proprietary global forecast that blends multiple numerical weather models with observations from its Tempest weather station network. 10-day worldwide horizon."
    },
    everywhereElse: {
        id: 'forecastModels.everywhereElse',
        defaultMessage: 'Everywhere else'
    },
    everywhereElseFoot: {
        id: 'forecastModels.everywhereElseFoot',
        defaultMessage: 'Used at any station your preferred models do not reach.'
    },
    everywhereElsePick: {
        id: 'forecastModels.everywhereElsePick',
        defaultMessage: 'Pick one'
    },
    fallbackBlend: {
        id: 'forecastModels.fallbackBlend',
        defaultMessage: 'SmartMixin blend'
    },
    fallbackBlendSub: {
        id: 'forecastModels.fallbackBlendSub',
        defaultMessage: 'Combines several models, each where it is strongest.'
    },
    fallbackEcmwf: {
        id: 'forecastModels.fallbackEcmwf',
        defaultMessage: 'ECMWF'
    },
    fallbackEcmwfSub: {
        id: 'forecastModels.fallbackEcmwfSub',
        defaultMessage: 'ECMWF HRES wherever it reaches.'
    },
    fallbackGfs: {
        id: 'forecastModels.fallbackGfs',
        defaultMessage: 'GFS'
    },
    fallbackGfsSub: {
        id: 'forecastModels.fallbackGfsSub',
        defaultMessage: "NOAA's global model. What every account uses today."
    },
    fallbackResolution: {
        id: 'forecastModels.fallbackResolution',
        defaultMessage: 'Highest resolution'
    },
    fallbackResolutionSub: {
        id: 'forecastModels.fallbackResolutionSub',
        defaultMessage: 'The finest mesh available at each station.'
    },
    forecastChipLabelWithRun: {
        id: 'forecastModels.forecastChipLabelWithRun',
        defaultMessage: '{model}, run {run}'
    },
    forecastChipRunHint: {
        id: 'forecastModels.forecastChipRunHint',
        defaultMessage: 'Long press to show or hide the latest run'
    },
    forecastComparisonDescription: {
        id: 'forecastModels.forecastComparisonDescription',
        defaultMessage: 'Easily compare forecast model outputs from several sources'
    },
    forecastFollowingPreferences: {
        id: 'forecastModels.forecastFollowingPreferences',
        defaultMessage: 'Following your preferences'
    },
    forecastModel: {
        id: 'forecastModels.forecastModel',
        defaultMessage: 'Forecast model'
    },
    forecastModelComparison: {
        id: 'forecastModels.forecastModelComparison',
        defaultMessage: 'Forecast model comparison'
    },
    forecastModelCoverage: {
        id: 'forecastModels.forecastModelCoverage',
        defaultMessage: 'Coverage'
    },
    forecastModelDescription: {
        id: 'forecastModels.forecastModelDescription',
        defaultMessage: 'Description'
    },
    forecastModels: {
        id: 'forecastModels.forecastModels',
        defaultMessage: 'Forecast models'
    },
    forecastModelScopeGlobal: {
        id: 'forecastModels.forecastModelScopeGlobal',
        defaultMessage: 'Global'
    },
    forecastModelScopeGlobalDescription: {
        id: 'forecastModels.forecastModelScopeGlobalDescription',
        defaultMessage: 'This model covers the entire planet.'
    },
    forecastModelScopeRegional: {
        id: 'forecastModels.forecastModelScopeRegional',
        defaultMessage: 'Regional'
    },
    forecastModelScopeRegionalDescription: {
        id: 'forecastModels.forecastModelScopeRegionalDescription',
        defaultMessage: 'This model only covers a specific region.'
    },
    forecastModelSpecifications: {
        id: 'forecastModels.forecastModelSpecifications',
        defaultMessage: 'Specifications'
    },
    forecastNoPinLocation: {
        id: 'forecastModels.forecastNoPinLocation',
        defaultMessage: 'No preferred model reaches this location — "everywhere else" decides.'
    },
    forecastNoPinStation: {
        id: 'forecastModels.forecastNoPinStation',
        defaultMessage: 'No preferred model reaches this station — "everywhere else" decides.'
    },
    forecastNoPreferredModels: {
        id: 'forecastModels.forecastNoPreferredModels',
        defaultMessage: 'No preferred models set yet.'
    },
    forecastOverrideElsewhere: {
        id: 'forecastModels.forecastOverrideElsewhere',
        defaultMessage: 'Your preferences apply everywhere else.'
    },
    forecastPickForLocation: {
        id: 'forecastModels.forecastPickForLocation',
        defaultMessage: 'Or pick one for this location'
    },
    forecastPickForStation: {
        id: 'forecastModels.forecastPickForStation',
        defaultMessage: 'Or pick one for this station'
    },
    forecastPinWinsLocation: {
        id: 'forecastModels.forecastPinWinsLocation',
        defaultMessage: '{model} — your first preferred model that reaches this location.'
    },
    forecastPinWinsStation: {
        id: 'forecastModels.forecastPinWinsStation',
        defaultMessage: '{model} — your first preferred model that reaches this station.'
    },
    forecastServedNowHere: {
        id: 'forecastModels.forecastServedNowHere',
        defaultMessage: 'Right now that is {model} here'
    },
    forecastSetForLocation: {
        id: 'forecastModels.forecastSetForLocation',
        defaultMessage: 'Set for this location'
    },
    forecastSetForStation: {
        id: 'forecastModels.forecastSetForStation',
        defaultMessage: 'Set for this station'
    },
    forecastSettingsRowSub: {
        id: 'forecastModels.forecastSettingsRowSub',
        defaultMessage: 'Preferred models, and what applies everywhere else'
    },
    forecastStopUsingHere: {
        id: 'forecastModels.forecastStopUsingHere',
        defaultMessage: 'Stop using here'
    },
    forecastUseForLocation: {
        id: 'forecastModels.forecastUseForLocation',
        defaultMessage: 'Use {model} for this location'
    },
    forecastUseForStation: {
        id: 'forecastModels.forecastUseForStation',
        defaultMessage: 'Use {model} for this station'
    },
    forecastUsePreferred: {
        id: 'forecastModels.forecastUsePreferred',
        defaultMessage: 'Use my preferred models'
    },
    frequencyHourly: {
        id: 'forecastModels.frequencyHourly',
        defaultMessage: 'Every hour'
    },
    horizon: {
        id: 'forecastModels.horizon',
        defaultMessage: 'Horizon'
    },
    horizonValue: {
        id: 'forecastModels.horizonValue',
        defaultMessage: 'up to {value} hours'
    },
    meshSize: {
        id: 'forecastModels.meshSize',
        defaultMessage: 'Grid size'
    },
    pickerShowAll: {
        id: 'forecastModels.pickerShowAll',
        defaultMessage: 'Show the full catalogue'
    },
    pickerUnreachable: {
        id: 'forecastModels.pickerUnreachable',
        defaultMessage: '{count, plural, one {# more model does} other {# more models do}} not reach any of your stations'
    },
    pinInUse: {
        id: 'forecastModels.pinInUse',
        defaultMessage: 'In use'
    },
    pinShadowed: {
        id: 'forecastModels.pinShadowed',
        defaultMessage: 'Never used \u2014 a model above covers all your stations'
    },
    pinSlots: {
        id: 'forecastModels.pinSlots',
        defaultMessage: '{used} of {max} · choose a model'
    },
    pinSlotsFull: {
        id: 'forecastModels.pinSlotsFull',
        defaultMessage: '{max, plural, one {All # slot used. Remove its model to add another.} other {All # slots used. Remove one to add another.}}'
    },
    pinsUncoveredCount: {
        id: 'forecastModels.pinsUncoveredCount',
        defaultMessage: '{used} of your {count, plural, one {# station} other {# stations}}: no preferred model reaches {used, plural, one {it} other {them}} — "everywhere else" decides.'
    },
    pinsUncoveredNamed: {
        id: 'forecastModels.pinsUncoveredNamed',
        defaultMessage: '{stations}: no preferred model reaches {count, plural, one {it} other {them}} — "everywhere else" decides.'
    },
    pinUnreachable: {
        id: 'forecastModels.pinUnreachable',
        defaultMessage: 'Never used \u2014 it reaches none of your stations'
    },
    pinUsedAt: {
        id: 'forecastModels.pinUsedAt',
        defaultMessage: 'Used at {stations}'
    },
    pinUsedAtAll: {
        id: 'forecastModels.pinUsedAtAll',
        defaultMessage: '{count, plural, one {Used at your station} other {Used at all # stations}}'
    },
    pinUsedAtSome: {
        id: 'forecastModels.pinUsedAtSome',
        defaultMessage: 'Used at {used} of {count, plural, one {# station} other {# stations}}'
    },
    preferredModels: {
        id: 'forecastModels.preferredModels',
        defaultMessage: 'Preferred models'
    },
    preferredModelsAll: {
        id: 'forecastModels.preferredModelsAll',
        defaultMessage: 'One list, all stations'
    },
    preferredModelsOne: {
        id: 'forecastModels.preferredModelsOne',
        defaultMessage: 'One list, applies everywhere'
    },
    publisher: {
        id: 'forecastModels.publisher',
        defaultMessage: 'Publisher'
    },
    removePreferredModel: {
        id: 'forecastModels.removePreferredModel',
        defaultMessage: 'Remove {model} from your preferred models'
    },
    resetForecastPreference: {
        id: 'forecastModels.resetForecastPreference',
        defaultMessage: 'Reset to default'
    },
    resetForecastPreferenceHint: {
        id: 'forecastModels.resetForecastPreferenceHint',
        defaultMessage: 'Clears your preferred models and goes back to the SmartMixin default.'
    },
    servedNowMany: {
        id: 'forecastModels.servedNowMany',
        defaultMessage: 'Right now: GFS at {count, plural, one {your station} other {all # stations}}.'
    },
    servedNowNone: {
        id: 'forecastModels.servedNowNone',
        defaultMessage: 'Right now: GFS wherever you look.'
    },
    title_SMARTMIXIN_MULTIMODEL: {
        id: 'forecastModels.title_SMARTMIXIN_MULTIMODEL',
        defaultMessage: 'SmartMixin multi-model'
    },
    title_WEATHERFLOW_FORECAST: {
        id: 'forecastModels.title_WEATHERFLOW_FORECAST',
        defaultMessage: 'Weatherflow Forecast'
    },
    weatherForecastModels: {
        id: 'forecastModels.weatherForecastModels',
        defaultMessage: 'Weather forecast models'
    }
});
